// extracted by mini-css-extract-plugin
export default {"footer":"P_cB","footer_logo":"P_cC","navLinks":"P_cD","column":"P_cF","columnHeading":"P_cG","copyright":"P_cH","socialMediaLinks":"P_cJ"};